module.exports = __webpack_public_path__ + "img/allow-down.06d9bb3f.svg";